import { useStore } from 'zustand';
import { ModelType, TrimType } from '../../../types';
import { formatNumber } from '../../../utils/helpers';
import { trackEvent } from '../../../utils/tracking';
import KiaLink from '../ui/KiaLink';
import CarouselCardRow from './CarouselCardRow';
import { getStoreByKey } from './store/CarouselStore';
import { CarouselFieldsEnum } from './types/CarouselTypes';

interface Props {
  trim: TrimType;
  model: ModelType;
  uniqId: string;
}

const CarouselOtherRows = ({ trim, model, uniqId }: Props) => {
  const { options, direction, selectedFinanceOption } = useStore(
    getStoreByKey(uniqId),
  );
  return (
    <>
      {trim.price ? (
        <>
          {(!options && !selectedFinanceOption) ||
          options?.fields?.includes(CarouselFieldsEnum.FROM_PRICE) ? (
            <CarouselCardRow
              uniqId={uniqId}
              className="border-none"
              label="Rek. ca pris"
              tooltip="inkl. moms"
            >
              <p>Från {formatNumber(trim.price)} kr</p>
            </CarouselCardRow>
          ) : null}
        </>
      ) : null}
      {!options ||
      options?.fields?.includes(CarouselFieldsEnum.CTA_RETAILER) ? (
        <div
          className={`hidden py-2 ${direction === 'vertical' ? 'sm:flex' : ''} flex-col min-w-[175px] max-w-[220px] gap-2`}
        >
          {!options ||
          options?.fields?.includes(CarouselFieldsEnum.CTA_RETAILER) ? (
            <KiaLink
              href="https://www.kia.com/se/provkor/#/"
              onClick={() =>
                trackEvent({
                  event: 'contact_dealer',
                  model,
                })
              }
            >
              Kontakta återförsäljare
            </KiaLink>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default CarouselOtherRows;
